// LVItemsTable — compact summary of raw LV extraction results.
// Shown after extraction completes, before the matching review phase.

import PageLink from "./PageLink";
import SourceLink from "./SourceLink";
import "./Matching.css";

export default function LVItemsTable({ items, documentUrl, documentName }) {
  if (!items || items.length === 0) return null;

  return (
    <div className="mt-section">
      <SourceLink url={documentUrl} name={documentName} />
      <div className="ds-table-wrap mt-scroll">
        <table className="ds-table">
          <thead>
            <tr>
              <th>Position</th>
              <th>Title</th>
              <th>Menge</th>
              <th>Einheit</th>
              <th>Page</th>
            </tr>
          </thead>
          <tbody>
            {items.map((item, i) => (
              <tr key={item.position || i}>
                <td className="mt-pos">{item.position || "—"}</td>
                <td className="mt-title">{item.title || "—"}</td>
                <td>{item.menge || "—"}</td>
                <td>{item.einheit || "—"}</td>
                <td className="mt-page">
                  {item.page_number != null ? (
                    <PageLink url={documentUrl} page={item.page_number} />
                  ) : "—"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
